import { FormikTextField } from 'formik-office-ui-fabric-react'
import { DangerousGoodInsertType, DangerousGoodSetType } from 'model'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FormType } from 'views/helpers'
import * as Yup from 'yup'
import { FieldStack, FieldStackItem, FormStack } from '../FormStack'

export type DangerousGoodFormValues =
  | DangerousGoodInsertType
  | DangerousGoodSetType

Yup.setLocale({
  date: {
    when: 'ERROR',
  },
})

export class DangerousGoodFormSchema {
  constructor() {
    return Yup.object().shape({
      unNumber: Yup.string().required(),
      link: Yup.string().url().nullable(),
    })
  }
}

export type DangerousGoodFormProps = {
  formType: FormType
}

export const DangerousGoodForm: React.FunctionComponent<
  DangerousGoodFormProps
> = ({ formType }) => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="unNumber"
          label={t('field.unNumber.label')}
          required={true}
          component={FormikTextField}
          readOnly={formType === FormType.update ? true : false}
        />
        <FieldStackItem
          name="description"
          label={t('field.description.label')}
          isRequired={false}
          component={FormikTextField}
        />
      </FieldStack>
    </FormStack>
  )
}
